import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button } from 'antd';
import NFButton from '../../primitives/NFButton';
import msgs from '../../../config/messages';
import formConfig from './formConfig';

function PdmiForm({
  onSubmit,
  initialValues = {},
  handleInitalValueReset = () => {
    console.log('im not here');
  },
  onReturnToMainPage,
}) {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, invalid, reset, values, submitting }) => (
        <form className="nf-pdmi-form" onSubmit={handleSubmit}>
          {/* <h3>Add Tooling Form</h3> */}

          <div>
            {formConfig.map((fieldConfig) => (
              <Field
                key={fieldConfig.name}
                {...fieldConfig}
              />
            ))}

            <Row>
              <Col sm={{ size: 7, offset: 2 }} className="text-center">

                <Button
                  key="back"
                  className="nf-button nf-button--gray-border"
                  onClick={onReturnToMainPage}
                  disabled={submitting}
                >
                  {msgs.Form.cancelButton}
                </Button>

                <NFButton
                  className="nf-button--gray-border"
                  onClick={() => {
                    handleInitalValueReset();
                    reset();
                  }}
                  disabled={submitting}
                >
                  Reset
                </NFButton>
                <NFButton
                  id='btnAddTooling'
                  className="nf-button--form nf-button--orange"
                  type="submit"
                  disabled={invalid || !values || submitting}
                >
                  {msgs.Form.submitButton}
                </NFButton>
              </Col>
            </Row>
          </div>
        </form>
      )}
    />
  );
}

PdmiForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleInitalValueReset: PropTypes.func,
  initialValues: PropTypes.object,
  onReturnToMainPage: PropTypes.func.isRequired,
};

PdmiForm.defaultProps = {
  initialValues: {},
  handleInitalValueReset: () => {
    console.log('im not here');
  },
};

export default PdmiForm;



// WEBPACK FOOTER //
// ./src/components/forms/AddToolingForm/AddToolingForm.jsx